import { UserSubscriptionDetails } from '@anm/api/modules/user';

const getWaveSubscription = (subscriptions: UserSubscriptionDetails[]) =>
  subscriptions.find(({ product }) => product === 'WAVE');

export default getWaveSubscription;
